(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (function() {
  const STORAGE_KEY = 'ww_wishlist_gids';
  
  // Get wishlist from localStorage
  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
      return [];
    }
  }
  
  // Save wishlist to localStorage
  function saveWishlist(gids) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(gids));
  }
  
  // Check if product is in wishlist
  function isInWishlist(gid) {
    return getWishlist().includes(gid);
  }
  
  // Toggle product in wishlist
  function toggleWishlist(gid) {
    let wishlist = getWishlist();
    const index = wishlist.indexOf(gid);
    
    if (index > -1) {
      wishlist.splice(index, 1);
      return false; // removed
    } else {
      wishlist.push(gid);
      return true; // added
    }
    saveWishlist(wishlist);
  }
  
  // Initialize hearts on page load
  function initHearts() {
    document.querySelectorAll('.ww-grid-heart').forEach(btn => {
      const gid = btn.getAttribute('data-product-gid');
      if (gid && isInWishlist(gid)) {
        btn.classList.add('is-active');
      }
    });
  }
  
  // Handle heart clicks
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.ww-grid-heart');
    if (!btn) return;
    
    e.preventDefault();
    const gid = btn.getAttribute('data-product-gid');
    if (!gid) return;
    
    const added = toggleWishlist(gid);
    btn.classList.toggle('is-active', added);
  });
  
  // Init on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHearts);
  } else {
    initHearts();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
